<template>
  <section class="cm" v-if="loaded">
    <div class="cm__header">
      <span class="cm__title">Envíos por correo</span>
      <span class="cm__sub">({{ messages.length }})</span>
    </div>

    <p v-if="!messages.length" class="cm__empty">Aún no se ha enviado ningún correo a este inquilino desde Parkos.</p>

    <div v-for="m in messages" :key="m.id" class="cm__row">
      <span class="mdi cm__icon" :class="STATES[m.state].icon"></span>
      <div class="cm__info">
        <div class="cm__kind">{{ m.kind }}</div>
        <div class="cm__meta">{{ m.to }} · {{ formatDate(m.createdAt) }}</div>
        <div v-if="m.detail" class="cm__detail">{{ m.detail }}</div>
      </div>
      <span class="cm__pill" :class="`cm__pill--${STATES[m.state].tone}`">{{ STATES[m.state].label }}</span>
    </div>
  </section>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import { getContractMessages } from '@/services/charges'

const props = defineProps({
  contractId: { type: String, required: true },
  version: { type: Number, default: 0 },
})

// "Sin enviar" = el sistema aún no tiene proveedor de correo (modo de pruebas) o la dirección no sirve: no salió nada.
const STATES = {
  DELIVERED: { label: 'Entregado', tone: 'green', icon: 'mdi-email-check-outline' },
  SENT: { label: 'Enviado', tone: 'green', icon: 'mdi-email-fast-outline' },
  QUEUED: { label: 'En cola', tone: 'blue', icon: 'mdi-email-sync-outline' },
  NOT_SENT: { label: 'Sin enviar', tone: 'amber', icon: 'mdi-email-off-outline' },
  FAILED: { label: 'Falló', tone: 'red', icon: 'mdi-email-alert-outline' },
}

const messages = ref([])
const loaded = ref(false)

async function load() {
  try {
    messages.value = await getContractMessages(props.contractId)
  } catch {
    messages.value = []
  } finally {
    loaded.value = true
  }
}
onMounted(load)
watch(() => [props.contractId, props.version], load)

function formatDate(value) {
  return new Date(value).toLocaleDateString('es-MX', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })
}
</script>

<style scoped>
.cm { padding: 0.9rem 1.25rem; border-top: 1px solid #f1f5f9; }
.cm__header { display: flex; align-items: baseline; gap: 0.4rem; margin-bottom: 0.4rem; }
.cm__title { font-family: var(--font-display); font-weight: 700; font-size: 13px; color: #1e3a5f; }
.cm__sub { font-family: var(--font-body); font-size: 11px; color: #94a3b8; }
.cm__empty { margin: 0; font-family: var(--font-body); font-size: 11px; color: #94a3b8; }
.cm__row { display: flex; align-items: center; gap: 0.5rem; min-height: 40px; padding: 0.3rem 0; border-bottom: 1px solid #f8fafc; }
.cm__icon { color: #64748b; font-size: 16px; flex-shrink: 0; }
.cm__info { flex: 1; min-width: 0; }
.cm__kind { font-family: var(--font-body); font-size: 12px; font-weight: 500; color: #1e3a5f; }
.cm__meta { font-family: var(--font-body); font-size: 11px; color: #64748b; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.cm__detail { font-family: var(--font-body); font-size: 10px; color: #b45309; margin-top: 2px; }
.cm__pill { flex-shrink: 0; font-family: var(--font-body); font-size: 10px; font-weight: 500; border-radius: 20px; padding: 2px 8px; }
.cm__pill--green { background: #dcfce7; color: #16a34a; }
.cm__pill--blue { background: #eff6ff; color: #3b82f6; }
.cm__pill--amber { background: #fef3c7; color: #b45309; }
.cm__pill--red { background: #fee2e2; color: #dc2626; }
</style>